<template>
  <v-card outlined tile>
    <v-row class="mt-1">
      <v-col>
        <div class="float-right mr-5">
          <v-btn color="primary" dark @click="csvClicked" depressed> <v-icon>mdi-download</v-icon>CSV </v-btn>
        </div>
      </v-col>
    </v-row>
    <v-card-text>
      <v-data-table
        fixed-header
        :headers="headers"
        :items="items"
        item-key="id"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        hide-default-footer
        class="v-data-table-outlined border-bottom-none"
      >
        <template v-slot:top>
          <v-card flat tile class="pa-3 v-card-border-bottom">
            <v-form v-model="valid" ref="form" @submit.prevent>
              <v-row class="d-flex align-center">
                <v-col
                  ><v-text-field
                    v-model="searchWord.deviceName"
                    :label="$t('serialNo')"
                    outlined
                    dense
                    hide-details
                  ></v-text-field
                ></v-col>
                <v-col
                  ><v-text-field
                    v-model="searchWord.optional_info_2"
                    :label="$t('customerSMachineNo')"
                    outlined
                    dense
                    hide-details
                  ></v-text-field
                ></v-col>
                <v-col
                  ><v-text-field
                    v-model="searchWord.deviceGroupName"
                    :label="$t('customer')"
                    outlined
                    dense
                    hide-details
                  ></v-text-field
                ></v-col>
                <v-col
                  ><v-text-field
                    v-model="searchWord.optional_info_1"
                    :label="$t('model')"
                    outlined
                    dense
                    hide-details
                  ></v-text-field
                ></v-col>
                <v-col>
                  <v-card-actions class="float-right">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="reset" color="primary" dark v-bind="attrs" v-on="on" class="mr-2" depressed>
                          <v-icon>mdi-close</v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t('deleteSearchConditions') }}</span>
                    </v-tooltip>

                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn @click="searchClicked" color="primary" dark v-bind="attrs" v-on="on" depressed>
                          <v-icon>mdi-magnify </v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t('search') }}</span>
                    </v-tooltip>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-form>
          </v-card>
          <v-row class="px-2">
            <v-col cols="6" sm="6" md="6" ls="6" xl="6">
              {{ $t(`display`) }}
              <div class="d-inline-block">
                <v-select
                  :value="selectedItemsPerPage"
                  :items="[
                    { text: '10', value: 10 },
                    { text: '20', value: 20 },
                    { text: $t(`all`), value: -1 },
                  ]"
                  item-text="text"
                  item-value="value"
                  @change="itemsPerPage = parseInt($event, 10)"
                />
              </div>
            </v-col>
            <v-col cols="6" sm="6" md="6" ls="6" xl="6" v-if="pageCount > 1">
              <div class="float-right">
                <v-btn
                  @click="changePage(1)"
                  :color="page !== 1 ? 'primary' : ''"
                  :dark="page !== 1"
                  small
                  :disabled="page === 1"
                  class="mr-3"
                  ><v-icon>mdi-page-first</v-icon>1</v-btn
                >
                <v-btn
                  @click="prevPage"
                  :color="page !== 1 ? 'primary' : ''"
                  :dark="page !== 1"
                  small
                  :disabled="page === 1"
                  class="mr-3"
                  ><v-icon>mdi-chevron-left</v-icon></v-btn
                >
                {{ page }}
                <v-btn
                  @click="nextPage"
                  :color="page !== pageCount ? 'primary' : ''"
                  :dark="page !== pageCount"
                  small
                  :disabled="page === pageCount"
                  class="ml-3"
                  ><v-icon>mdi-chevron-right</v-icon></v-btn
                >
                <v-btn
                  @click="changePage(pageCount)"
                  :color="page !== pageCount ? 'primary' : ''"
                  :dark="page !== pageCount"
                  small
                  :disabled="page === pageCount"
                  class="ml-3"
                  >{{ pageCount }}<v-icon>mdi-page-last</v-icon></v-btn
                >
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.device_name_locale`]="{ item }">
          <router-link :to="{ name: 'CompressorInfo', params: { model_id: item.model_id, serial_no: item.serial_no } }">
            <span class="text-subtitle-1">{{ item[`device_name_locale${localeId}`] }}</span>
          </router-link>
        </template>
        <template v-slot:[`item.device_group_name_locale`]="{ item }">
          <span class="text-subtitle-1">{{ item[`device_group_name_locale${localeId}`] }}</span>
        </template>
        <template v-slot:[`item.optional_info_1`]="{ item }">
          <span class="text-subtitle-1">{{ item.optional_info_1 }}</span>
        </template>
        <template v-slot:[`item.optional_info_2`]="{ item }">
          <span class="text-subtitle-1">{{ item.optional_info_2 }}</span>
        </template>
        <template v-slot:[`item.additional.drivingStatus`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.drivingStatus }}</span>
        </template>
        <template v-slot:[`item.additional.alermInfo`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.alermInfo }}</span>
        </template>
        <template v-slot:[`item.additional.notCommunicated`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.notCommunicated }}</span>
        </template>
        <template v-slot:[`item.additional.runninghour`]="{ item }">
          <span class="text-subtitle-1">{{ item.additional.runninghour | numberFormat }}</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import csv from '@/utils/csv';
  import modelMapping from '../resources/model_mapping.json';

  export default {
    name: 'Table',
    components: {},
    mixins: [csv],
    data: () => ({
      page: 1,
      pageCount: 0,
      itemsPerPage: -1,
      selectedItemsPerPage: undefined, // selectの選択保持用
      valid: true,
      searchWord: {
        deviceName: '',
        optional_info_2: '',
        optional_info_1: '',
        deviceGroupName: '',
      },
      internalSearchWord: {
        deviceName: '',
        optional_info_2: '',
        optional_info_1: '',
        deviceGroupName: '',
      },
      items: [],
    }),
    props: {
      value: null,
      tabs: null,
    },
    filters: {
      numberFormat: (value) => {
        if (isNaN(value) || value === undefined) {
          return '';
        }
        let formatter = new Intl.NumberFormat('ja-JP');
        return formatter.format(value);
      },
    },
    computed: {
      groupId() {
        return this.$props.value;
      },
      headers() {
        return [
          {
            text: this.$t('serialNo'),
            align: 'start',
            value: 'device_name_locale',
            filterable: true,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('customerSMachineNo'),
            align: 'start',
            value: 'optional_info_2',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('model'),
            align: 'start',
            value: 'optional_info_1',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('customer'),
            align: 'start',
            value: 'device_group_name_locale',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('runningCondition'),
            align: 'start',
            value: 'additional.drivingStatus',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('alarmInformation'),
            align: 'start',
            value: 'additional.alermInfo',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('notCommunicated'),
            align: 'start',
            value: 'additional.notCommunicated',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
          {
            text: this.$t('runningHour'),
            align: 'end',
            value: 'additional.runninghour',
            filterable: false,
            class: 'text-subtitle-1 font-weight-bold',
          },
        ];
      },
      localeId() {
        switch (this.$i18n.locale) {
          case 'en':
            return 1;
          case 'ja':
            return 2;
          case 'zh':
            return 3;
        }
        return 2;
      },
    },
    watch: {
      groupId(val) {
        this.getDevice(val);
        this.reset();
      },
    },
    created() {
      this.selectedItemsPerPage = { text: this.$t('all'), value: -1 };

      this.getDevice(this.groupId);
    },
    mounted() {},
    beforeMount() {},
    methods: {
      _util_split(array, number) {
        const length = Math.ceil(array.length / number);
        return new Array(length).fill().map((_, i) => array.slice(i * number, (i + 1) * number));
      },
      // measureTimeをmomentオブジェクトに変換
      _util_getMomentObj(value) {
        const year = parseInt(value.substring(0, 4));
        const month = parseInt(value.substring(4, 6));
        const date = parseInt(value.substring(6, 8));
        const hour = parseInt(value.substring(8, 10));
        const min = parseInt(value.substring(10, 12));
        const sec = parseInt(value.substring(12, 14));
        const msec = parseInt(value.substring(14, 20));
        return this.$moment(new Date(year, month, date, hour, min, sec, msec));
      },
      async getSensorData(devices) {
        // 運転データ関連
        // 1回で運転データを取得する数 多すぎるとエラーになるので分割して取得
        const DIVID_COUNT = 5;
        const sensors = await devices.map((el) => {
          return (
            {
              model_id: el.model_id,
              serial_no: el.serial_no,
              sensorId: 'sn_D027',
            },
            {
              model_id: el.model_id,
              serial_no: el.serial_no,
              sensorId: 'sn_D020_021',
            }
          );
        });

        // 分割して取得
        const splited = this._util_split(sensors, DIVID_COUNT);
        let apiResult = [];
        for (const tmp of splited) {
          const params = {
            sensor_list: tmp,
          };
          // センサーデータを取得
          const res = await this.apiRequest('/v1/sensor-data-file-mgt/getLatestSensorData', 'POST', params);
          if (res) {
            apiResult = apiResult.concat(res);
          }
        }

        if (apiResult) {
          const compressors = apiResult.map((el) => {
            let compressor = {
              modelId: el.modelId,
              serialNo: el.serialNo,
            };
            // LED ランプ状態(Hex)のオブジェクトのみ抽出
            const panelLamp = el.timeList.filter((item) => item.sensorId === 'sn_D027');
            // センサーのデータリスト配列が空の場合未疎通とみなす
            if (panelLamp[0].dataList.length > 0) {
              // 10進数を2進数に変換し、1桁ずつ配列に分け配列を逆順にする
              const lampDatas = Number(panelLamp[0].dataList[0].data).toString(2).match(/.{1}/g).reverse();
              const mapping = modelMapping[el.modelId];
              // Startフラグ
              compressor.start = Boolean(lampDatas[mapping.start] === '1');
              // getLatestSensorDataは日付の文字列が特殊なので変換
              const fromDate = this._util_getMomentObj(panelLamp[0].dataList[0].measureTime);
              const toDate = this.$moment.utc();
              const diffDate = toDate.utc().diff(fromDate, 'minutes');
              // 最新のデータ取得時刻が現在の時刻と比べて160分以上前であれば「通信断」と判定
              compressor.connection = Boolean(diffDate < 160);
            }

            const runninghour = el.timeList.filter((item) => item.sensorId === 'sn_D020_021');
            if (runninghour[0].dataList.length > 0) {
              compressor.runninghour = runninghour[0].dataList[0].data;
            }
            return compressor;
          });
          return compressors;
        }
      },
      async getAdditionalIinformation(devices) {
        const compressors = await this.getSensorData(devices);

        for (const el of devices) {
          const compressor = compressors.find((comp) => comp.modelId === el.model_id && comp.serialNo === el.serial_no);
          if (compressor) {
            const status =
              compressor.start && compressor.connection
                ? this.$t('running')
                : !compressor.connection
                ? this.$t('disconnected')
                : this.$t('stop');

            const alermInfo = await this._addInfo_getAlermInfo(el);

            el.additional = {
              drivingStatus: status,
              runninghour: compressor.runninghour,
              notCommunicated: compressor.start === undefined ? this.$t('notCommunicated') : '',
              alermInfo: alermInfo,
            };
          }
        }
        return devices;
      },
      async _addInfo_getAlermInfo(device) {
        // アラームを取得
        const params = {
          get_class: '4',
          sort: '-event_time',
          event_level: '1,2,3',
          incident_class: '1',
          device_group_id: device.device_group_id,
        };
        params['device_list[0].model_id'] = device.model_id;
        params['device_list[0].serial_no'] = device.serial_no;

        console.dir(params);

        const res = await this.apiRequest('/v1/alarm-event-mgt/eventIncidentStatus', 'GET', params);
        console.dir(res);
        if (res) {
          const value = res
            .map((el) => el.event_level)
            .sort()
            .reverse()[0];

          // event_levelの変換
          if (value === '3') {
            return this.$t('emergency'); //'E'
          } else if (value === '2') {
            return this.$t('caution'); //'C'
          } else if (value === '1') {
            return this.$t('maintenance'); //'M'
          }
          return '';
        }
        return '';
      },

      async getDevice(groupId) {
        this.$store.commit('loading/start_loading');
        try {
          const searchResult = await this.$store.getters['groupAuthorities/getDeviceBydeviceGroupId'](groupId);
          this.items = await this.getAdditionalIinformation(searchResult);
        } catch (error) {
          console.error(error);
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      reset() {
        this.$refs.form.reset(); //internalSearchWordの各項目はnullが入る
        this.internalSearchWord.deviceName = undefined;
        this.internalSearchWord.optional_info_2 = undefined;
        this.internalSearchWord.optional_info_1 = undefined;
        this.internalSearchWord.deviceGroupName = undefined;

        this.getDevice(this.groupId);
      },
      async searchClicked() {
        console.log('サーチ');
        this.$store.commit('loading/start_loading');
        try {
          // 別オブジェクトに格納
          this.internalSearchWord.deviceName = this.searchWord.deviceName;
          this.internalSearchWord.optional_info_2 = this.searchWord.optional_info_2;
          this.internalSearchWord.optional_info_1 = this.searchWord.optional_info_1;
          this.internalSearchWord.deviceGroupName = this.searchWord.deviceGroupName;

          // 何も入力されていないと全部取れてしまうので検索しない
          if (
            this.internalSearchWord.deviceName ||
            this.internalSearchWord.optional_info_2 ||
            this.internalSearchWord.optional_info_1 ||
            this.internalSearchWord.deviceGroupName
          ) {
            await this.searchDevice();
          }
        } finally {
          this.$store.commit('loading/end_loading');
        }
      },
      async searchDevice() {
        console.info('検索開始');
        try {
          // 検索で絞り込むためのコールバック
          const callback = async (group, getDevice) => {
            const devices = await getDevice(group.device_group_id);

            let result = [];
            if (devices) {
              result = devices.filter((el) => {
                let checked = true;
                // 部分一致でチェック
                if (checked && this.internalSearchWord.deviceName) {
                  checked = !el[`device_name_locale${this.localeId}`]
                    ? false
                    : el[`device_name_locale${this.localeId}`].indexOf(this.internalSearchWord.deviceName) >= 0;
                }
                if (checked && this.internalSearchWord.optional_info_2) {
                  checked = !el[`optional_info_2`]
                    ? false
                    : el[`optional_info_2`].indexOf(this.internalSearchWord.optional_info_2) >= 0;
                }
                if (checked && this.internalSearchWord.optional_info_1) {
                  checked = !el.optional_info_1
                    ? false
                    : el.optional_info_1.indexOf(this.internalSearchWord.optional_info_1) >= 0;
                }
                if (checked && this.internalSearchWord.deviceGroupName) {
                  checked = !el[`device_group_name_locale${this.localeId}`]
                    ? false
                    : el[`device_group_name_locale${this.localeId}`].indexOf(this.internalSearchWord.deviceGroupName) >=
                      0;
                }
                return checked;
              });
            }
            return result;
          };

          const searchResult = await this.$store.getters['groupAuthorities/searchGroup'](this.groupId, callback);
          this.items = await this.getAdditionalIinformation(searchResult);
        } catch (error) {
          console.error(error);
        }
      },
      changePage(value) {
        // ページング処理、先頭ページ、最終ページへのジャンプ用
        this.page = value;
      },
      prevPage() {
        if (this.page !== 1) {
          this.page--;
        }
      },
      nextPage() {
        if (this.page !== this.pageCount) {
          this.page++;
        }
      },
      csvClicked() {
        console.log('CSVダウンロード');

        let items = [];
        const header = [
          this.$t('serialNo'),
          this.$t('customerSMachineNo'),
          this.$t('model'),
          this.$t('customer'),
          this.$t('runningCondition'),
          this.$t('alarmInformation'),
          this.$t('notCommunicated'),
          this.$t('runningHour'),
        ];
        items.push(header);

        this.items.forEach((el) => {
          let lineData = [];
          lineData.push(el[`device_name_locale${this.localeId}`]);
          lineData.push(el.optional_info_2);
          lineData.push(el.optional_info_1);
          lineData.push(el[`device_group_name_locale${this.localeId}`]);
          lineData.push(el.additional.drivingStatus);
          lineData.push(el.additional.alermInfo);
          lineData.push(el.additional.notCommunicated);
          lineData.push(el.additional.runninghour);
          items.push(lineData);
        });

        const fileName = `${this.$moment().format('YYYYMMDD')}.csv`;
        this.downloadCsv(fileName, items);
      },
    },
  };
</script>
<style scoped></style>
